module.exports = __webpack_public_path__ + "img/10_bohle.e002d477.jpeg";